import * as ActionName from '../action-names';

import InitialState from '../initial-state';

export default function userReducer(
  state = InitialState.getState().userContext,
  action
) {
  switch (action.type) {
    case ActionName.LOGIN_IN_PROGRESS: {
      return Object.assign({}, state, {
        isLoginInProgress: true
      });
    }
    case ActionName.LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isLoggedIn: true,
        isLoginInProgress: false,
        kambiSessionId: action.userData.sessionId
      });
    case ActionName.LOGIN_FAILED:
      return Object.assign({}, state, {
        isLoggedIn: false,
        isLoginInProgress: false
      });
    case ActionName.LOGOUT_SUCCESS:
      return Object.assign({}, state, {
        isLoggedIn: false,
        isLoginInProgress: false,
        kambiSessionId: null,
        cid: null
      });
    case ActionName.SESSION_EXTEND_SUCCESS:
      return state;
    case ActionName.KICK_USER:
      return Object.assign({}, state, {
        isLoggedIn: false,
        isLoginInProgress: false,
        kambiSessionId: null
      });
    case ActionName.CHANGE_ODDS_FORMAT:
      return Object.assign({}, state, { oddsFormat: action.newOddsFormat });
    case ActionName.UPDATE_USER_CONTEXT:
      return Object.assign({}, state, action.newUserDetails);
    case ActionName.SET_USER_TOKEN:
      return Object.assign({}, state, { userToken: action.token });
    default:
      return state;
  }
}
